import { createReducer, on } from '@ngrx/store';
import {InfoSideMenuItem} from "../../interfaces/info-side-menu-item";
import {setArchiveSortState, setPageLinkPrefix, setSideMenuItems} from "../actions/page.actions";


export const pageFeatureKey = 'page';

export interface PageState {
  sideMenuItems: InfoSideMenuItem[],
  linkPrefix: string,
  showArchiveSort: boolean
}

export const initialState: PageState = {
  sideMenuItems: new Array(0),
  linkPrefix: "",
  showArchiveSort: false
};

export const reducer = createReducer(
  initialState,
  on(setSideMenuItems, (state, action) => {
    return {
      ...state,
      sideMenuItems: action.sideMenuItems
    };
  }),
  on(setPageLinkPrefix, (state, action) => {
    return {
      ...state,
      linkPrefix: action.prefix
    };
  }),
  on(setArchiveSortState, (state, action) => {
    return {
      ...state,
      showArchiveSort: action.state
    };
  })
);
